<template>
    <div>
        <h4>Features</h4>
        
        <container>
            <row>
                <column :col="12" :md="8">
                    <h5>Outdoor</h5>
                    <form-group v-for="(option, index) in outdoors" :key="`search-bar-outdoors-features-${index}`">
                        <form-checkbox v-model="selected[index]" @input="() => emitUpdateDelay(index)">
                            {{ option }}
                        </form-checkbox>
                    </form-group>

                </column>

                <column :col="12" :md="8">
                    <h5>Amenities</h5>
                    <form-group v-for="(option, index) in amenities" :key="`search-bar-amenities-features-${index}`">
                        <form-checkbox v-model="selected[index]" @input="() => emitUpdateDelay(index)">
                            {{ option }}
                        </form-checkbox>
                    </form-group>
                </column>

                <column :col="12" :md="8">

                    <hr v-if="uiStore.isMobile" class="my-4" />


                    <h5>Location</h5>
                    <form-group v-for="(option, index) in locations" :key="`search-bar-locations-features-${index}`">
                        <form-checkbox v-model="selected[index]" @input="() => emitUpdateDelay(index)">
                            {{ option }}
                        </form-checkbox>
                    </form-group>

                    <template v-if="!uiStore.isMobile">
                        <h5 class="mt-4">Type</h5>
                        <form-group v-for="(option, index) in types" :key="`search-bar-types-features-${index}`">
                            <form-checkbox v-model="selected[index]" @input="() => emitUpdateDelay(index)">
                                {{ option }}
                            </form-checkbox>
                        </form-group>
                    </template>
                </column>

                <column v-if="uiStore.isMobile" :col="12" :md="8">

                    <hr class="my-4" />

                    <h5>Type</h5>
                    <form-group v-for="(option, index) in types" :key="`search-bar-types-features-${index}`">
                        <form-checkbox v-model="selected[index]" @input="() => emitUpdateDelay(index)">
                            {{ option }}
                        </form-checkbox>
                    </form-group>

                </column>
            </row>
        </container>
    </div>
    
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                selected: {},
            };
        },

        emits: ['update:modelValue', 'featuresLabels'],

        created() {
            this.setSearchData();

            this.$watch(
                () => this.modelValue,
                this.setSearchData,
                { deep: true }
            );
        },

        props: {
            modelValue: {
                type: Object,
                default: null,
            },

            outdoors: {
                type: Object,
                required: true,
            },

            amenities: {
                type: Object,
                required: true,
            },

            locations: {
                type: Object,
                required: true,
            },

            types: {
                type: Object,
                required: true,
            },
        },

        methods: {

            setSearchData() {
                let vals = this.modelValue || [];
                
                let keys = [
                    ...Object.keys(this.outdoors),
                    ...Object.keys(this.amenities),
                    ...Object.keys(this.locations),
                    ...Object.keys(this.types),
                ];

                for (let i=0; i<keys.length; i++) {
                    this.selected[keys[i]] = (vals.indexOf(keys[i]) != -1);
                }
            },

            emitUpdateDelay(index) {
                // make sure we only have one pool selected
                if (index == 'p:5') this.selected['p:1'] = false;
                else if (index == 'p:1') this.selected['p:5'] = false;

                if (index == 't:3') this.selected['t:2'] = false;
                else if (index == 't:2') this.selected['t:3'] = false;
                
                requestAnimationFrame(this.emitUpdate);
            },

            emitUpdate() {
                let data = [];
                for (const [key, val] of Object.entries(this.selected)) {
                    if (val) {
                        data.push(key);
                    }
                }
                
                this.$emit('update:modelValue', data);
            },
        }

    };

</script>
